import { useEffect } from 'modules/core/hooks/useEffect'

import { BlockingIssuesModal } from 'modules/integrations/components/SyncButton/Modals/BlockingIssuesModal'
import { ConfirmationModal } from 'modules/integrations/components/SyncButton/Modals/ConfirmationModal'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useBlockingIssuesLazyQuery } from 'modules/integrations/hooks/SyncContext/useBlockingIssuesLazyQuery'

export interface ModalsProps {
  setShowModal: (showModal: boolean) => void
  onConfirm?: () => void
}

export const Modals = ({ setShowModal, onConfirm }: ModalsProps) => {
  const { runSynchronisation } = usePrivateIntegrationsSyncContext()
  const { fetchBlockingIssues, blockingIssues, blockingIssuesLoading, anyValidSyncable } =
    useBlockingIssuesLazyQuery()

  const syncCompensationsConfirmationClick = async () => {
    setShowModal(false)
    onConfirm?.()
    await runSynchronisation()
  }

  useEffect(() => {
    fetchBlockingIssues()
  }, [])

  if (blockingIssuesLoading) return null

  return (
    <>
      {blockingIssues.length > 0 ? (
        <BlockingIssuesModal
          onClose={() => setShowModal(false)}
          blockingIssues={blockingIssues}
          availableSync={anyValidSyncable}
          onSubmit={anyValidSyncable ? syncCompensationsConfirmationClick : undefined}
        />
      ) : (
        <ConfirmationModal
          onClose={() => setShowModal(false)}
          onSubmit={syncCompensationsConfirmationClick}
        />
      )}
    </>
  )
}
